/* global Swiper */

itsoftApp.createModule("js-slider-3", ["slidersLibrary"], function() {
    var sliderParent = $(".js-slider-3");
    if (!sliderParent.length) {
        return false;
    }

    var swiper;
    var init = function(){
        swiper = new Swiper(sliderParent.get(0), {
            pagination: ".js-pagination-3",
            autoplay: 7500,
            paginationClickable: true,
            mousewheelControl: false,
            spaceBetween: 30,
            longSwipesRatio: 800,
            autoplayDisableOnInteraction: false,

        });
        DEBUG && console.log("[module swiper] slider initialized");
    };

    $(".js-pagination-2").on("click", function(){
        swiper.startAutoplay();
    })

    itsoftApp.modules.slidersLibrary.addEvent(init);
});

